import { useCurrentOrg } from "@/hooks/use-current-org";

/**
 * Whether the current user can create/update/delete teams or manage their members.
 * Backend is the source of truth; this only avoids dead UI controls.
 *
 * If the backend cannot extend Better Auth `access` to allow `manager` on team
 * mutations, drop `isManager` from this expression.
 */
export function useCanManageTeams(): boolean {
  const { isOwner, isAdmin, isManager } = useCurrentOrg();
  return Boolean(isOwner || isAdmin || isManager);
}
